import { z } from "zod"

export const CustomerCustomFieldSchema = z.object({
  id: z.number(),
  project_id: z.number(),
  field_name: z.string(),
  field_type: z.enum(["string", "number", "boolean", "mixed"]),
  created_at: z.string(),
  updated_at: z.string(),
})

export type CustomerCustomField = z.infer<typeof CustomerCustomFieldSchema>
